<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content settings-content">
      <div class="page-header settings-pg-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Settings</h4>
            <h6>Manage your settings on portal</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"
              ><i data-feather="rotate-ccw" class="feather-rotate-ccw"></i
            ></a>
          </li>
          <li>
            <a
              ref="collapseHeader"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Collapse"
              @click="toggleCollapse"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="settings-wrapper d-flex">
            <div class="sidebars settings-sidebar theiaStickySidebar" id="sidebar2">
              <settings-sidebar></settings-sidebar>
            </div>
            <div class="settings-page-wrap">
              <div class="setting-title">
                <h4>Email Settings</h4>
              </div>
              <div class="page-header text-end justify-content-end">
                <a href="javascript:void(0);" class="btn-added btn-primary"
                  ><i data-feather="mail" class="me-2"></i>Send test email</a
                >
              </div>
              <div class="row">
                <div class="col-xxl-4 col-xl-6 col-lg-12 col-md-6 d-flex">
                  <div class="connected-app-card email-setting d-flex w-100">
                    <ul class="w-100">
                      <li class="flex-column align-items-start">
                        <div
                          class="d-flex align-items-center justify-content-between w-100 mb-2"
                        >
                          <div class="security-type d-flex align-items-center">
                            <div class="security-title">
                              <h5>PHP Mailer</h5>
                            </div>
                          </div>
                        </div>
                        <p>
                          Used to send emails safely and easily via PHP code from a web
                          server.
                        </p>
                      </li>
                      <li>
                        <div class="integration-btn">
                          <a href="" data-bs-toggle="modal" data-bs-target="#php-mail"
                            ><i data-feather="tool" class="me-2"></i>Connect</a
                          >
                        </div>
                        <div
                          class="status-toggle modal-status d-flex justify-content-between align-items-center ms-2"
                        >
                          <input type="checkbox" id="user1" class="check" checked />
                          <label for="user1" class="checktoggle"> </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-xxl-4 col-xl-6 col-lg-12 col-md-6 d-flex">
                  <div class="connected-app-card email-setting d-flex w-100">
                    <ul class="w-100">
                      <li class="flex-column align-items-start">
                        <div
                          class="d-flex align-items-center justify-content-between w-100 mb-2"
                        >
                          <div class="security-type d-flex align-items-center">
                            <div class="security-title">
                              <h5>SMTP</h5>
                            </div>
                          </div>
                        </div>
                        <p>
                          SMTP is used to send, relay or forward messages from a mail
                          client.
                        </p>
                      </li>
                      <li>
                        <div class="integration-btn">
                          <a href="" data-bs-toggle="modal" data-bs-target="#smtp-mail"
                            ><i data-feather="tool" class="me-2"></i>Connect</a
                          >
                        </div>
                        <div
                          class="status-toggle modal-status d-flex justify-content-between align-items-center ms-2"
                        >
                          <input type="checkbox" id="user2" class="check" checked />
                          <label for="user2" class="checktoggle"> </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-xxl-4 col-xl-6 col-lg-12 col-md-6 d-flex">
                  <div class="connected-app-card email-setting d-flex w-100">
                    <ul class="w-100">
                      <li class="flex-column align-items-start">
                        <div
                          class="d-flex align-items-center justify-content-between w-100 mb-2"
                        >
                          <div class="security-type d-flex align-items-center">
                            <div class="security-title">
                              <h5>SendGrid</h5>
                            </div>
                          </div>
                          <div class="connect-btn">
                            <a href="javascript:void(0);">Connected</a>
                          </div>
                        </div>
                        <p>
                          Cloud-based email marketing tool that assists marketers and
                          developers .
                        </p>
                      </li>
                      <li>
                        <div class="integration-btn">
                          <a href="" data-bs-toggle="modal" data-bs-target="#test-mail"
                            ><i data-feather="tool" class="me-2"></i>View Integration</a
                          >
                        </div>
                        <div
                          class="status-toggle modal-status d-flex justify-content-between align-items-center ms-2"
                        >
                          <input type="checkbox" id="user3" class="check" checked />
                          <label for="user3" class="checktoggle"> </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <email-settings-modal></email-settings-modal>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;

      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },
  },
};
</script>
